export const getIsRequiredFlexLoading = (state) => 
  Object.keys(state.reisadviezen.flex).some(flexType => {
    const flex = state.reisadviezen.flex[flexType];
    return flex.loading && flex.isRequired;
  });


// WEBPACK FOOTER //
// ./src/utils/flexRules.js